// extracted by mini-css-extract-plugin
export default {"root":"IconGlobe_root__Q+r9b"};